import { c as _c } from "react/compiler-runtime";
import { ArrowRight, Ruler } from 'lucide-react';
import { Link } from 'react-router-dom';
import { EmptyState } from '@/components/app-ui/EmptyState';
import { Button } from '@/components/ui/button';
import { useTranslation } from '@/hooks/use-translation';

/**
 * A design page before the piano has been measured far enough to design it:
 * what is missing, and the way to it, where a grey alert gave neither.
 */
export const NotEnoughData = t0 => {
  const $ = _c(10);
  const {
    description,
    title
  } = t0;
  const {
    t
  } = useTranslation();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Ruler />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== t) {
    t2 = t("Complete the measurements");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ArrowRight />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = <Button asChild={true} variant="outlineStrong" className="min-h-[46px]"><Link to="/measure">{t2}{t3}</Link></Button>;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== description || $[7] !== t4 || $[8] !== title) {
    t5 = <section className="flex justify-center rounded-md border border-ptl-rule-strong bg-card px-6 py-14"><EmptyState icon={t1} title={title} text={description} actions={t4} /></section>;
    $[6] = description;
    $[7] = t4;
    $[8] = title;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};